var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  validationDate: () => validationDate,
  validationInvalidMessage: () => validationInvalidMessage,
  validationLength: () => validationLength,
  validationLengthMessage: () => validationLengthMessage,
  validationMax: () => validationMax,
  validationMaxDate: () => validationMaxDate,
  validationMaxDateMessage: () => validationMaxDateMessage,
  validationMaxMessage: () => validationMaxMessage,
  validationMin: () => validationMin,
  validationMinDate: () => validationMinDate,
  validationMinDateMessage: () => validationMinDateMessage,
  validationMinMessage: () => validationMinMessage,
  validationOptionInvalidMessage: () => validationOptionInvalidMessage,
  validationOptionsMessage: () => validationOptionsMessage,
  validationRegexMessage: () => validationRegexMessage,
  validationRequired: () => validationRequired,
  validationRequiredMessage: () => validationRequiredMessage,
  validationTextLengthMessage: () => validationTextLengthMessage
});
var import_moment = __toModule(require("moment"));
var import_index = __toModule(require("./index"));
const validationRequired = (value, DEFAULT_VALUE) => {
  return value !== DEFAULT_VALUE;
};
const validationMin = (value, min) => {
  return !(0, import_index.isUndefined)(min) ? value >= min : true;
};
const validationMax = (value, max) => {
  return !(0, import_index.isUndefined)(max) ? value <= max : true;
};
const validationLength = (value, length) => {
  return length ? value.length <= length : true;
};
const validationDate = (value) => {
  const date = (0, import_moment.default)((0, import_index.formatDate)(value), true);
  return date.isValid();
};
const validationMinDate = (value, min) => {
  const date = (0, import_moment.default)((0, import_index.formatDate)(value));
  const minDate = (0, import_moment.default)((0, import_index.formatDate)(min));
  return !date.isBefore(minDate);
};
const validationMaxDate = (value, max) => {
  const date = (0, import_moment.default)((0, import_index.formatDate)(value));
  const maxDate = (0, import_moment.default)((0, import_index.formatDate)(max));
  return !date.isAfter(maxDate);
};
const validationInvalidMessage = ({ NAME, value }, verbose = true) => {
  return verbose ? `Invalid ${NAME}: value=${value}, type=${typeof value}` : "invalid_field";
};
const validationRequiredMessage = ({ NAME, value }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. Field are required: value=${value}, type=${typeof value}` : "invalid_required";
};
const validationMinMessage = ({ NAME, value, min }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. ${value} smaller than ${min}: value=${value}, type=${typeof value}` : "invalid_min";
};
const validationMaxMessage = ({ NAME, value, max }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. ${value} greater than ${max} : value=${value}, type=${typeof value}` : "invalid_max";
};
const validationLengthMessage = ({ NAME, value }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. Unexpected length: value=${value}, type=${typeof value}, length=${value.length}` : "invalid_length";
};
const validationTextLengthMessage = ({ NAME, value, length }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. Length ${value.length} is greater than expected ${length} : value=${value}, type=${typeof value}` : "invalid_text_length";
};
const validationRegexMessage = ({ NAME, value }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. Does not validate regular expression: value=${value}, length=${value.length}, type=${typeof value}` : "invalid_regex";
};
const validationOptionInvalidMessage = ({ value, options }, verbose = true) => {
  const optionsDetails = options.map((option) => `value=${option}, type=${typeof option}`).join(". ");
  return verbose ? `There is no option that matches: value=${value}, type=${typeof value}. Valid options: ${optionsDetails}` : "invalid_singleoption";
};
const validationOptionsMessage = (verbose = true) => {
  return verbose ? `There are no valid options for this yayoyaki` : "invalid_singleoption";
};
const validationMinDateMessage = ({ NAME, value, min }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. ${value} smaller than ${min}: value=${value}, type=${typeof value}` : "invalid_min_date";
};
const validationMaxDateMessage = ({ NAME, value, max }, verbose = true) => {
  return verbose ? `Invalid ${NAME}. ${value} greater than ${max}: value=${value}, type=${typeof value}` : "invalid_max_date";
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  validationDate,
  validationInvalidMessage,
  validationLength,
  validationLengthMessage,
  validationMax,
  validationMaxDate,
  validationMaxDateMessage,
  validationMaxMessage,
  validationMin,
  validationMinDate,
  validationMinDateMessage,
  validationMinMessage,
  validationOptionInvalidMessage,
  validationOptionsMessage,
  validationRegexMessage,
  validationRequired,
  validationRequiredMessage,
  validationTextLengthMessage
});
